// extracted by mini-css-extract-plugin
export default {"form_button":"sections-tab_form_button__l8T8Q"};